export enum OrderAction {
  ADD_TAGS = 'ADD_TAGS',
  ASSIGN_USERS = 'ASSIGN_USERS',
  CANCEL = 'CANCEL',
  CLONE = 'CLONE',
  CONSOLIDATE = 'CONSOLIDATE',
  REQUEST_SPOT_MARKET_BID = 'REQUEST_SPOT_MARKET_BID',
  SEND_TO_ROUTE_BUILDER = 'SEND_TO_ROUTE_BUILDER',
  SHARE = 'SHARE',
}
